"use client"

import { useState } from "react"
import { Link as RouterLink } from "react-router-dom"
import { Box, TextField, Typography, Link, Alert } from "@mui/material"
import { useAuth } from "../../contexts/AuthContext"
import LoadingButton from "../../components/common/LoadingButton"

const ForgotPassword = () => {
  const { forgotPassword } = useAuth()
  const [email, setEmail] = useState("")
  const [error, setError] = useState("")
  const [success, setSuccess] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleChange = (e) => {
    setEmail(e.target.value)
    setError("")
  }

  const validateForm = () => {
    if (!email) {
      setError("Email is required")
      return false
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      setError("Email is invalid")
      return false
    }
    return true
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!validateForm()) return

    setLoading(true)
    try {
      const result = await forgotPassword(email)
      if (result.success) {
        setSuccess(true)
      } else {
        setError(result.error)
      }
    } catch (error) {
      setError("An error occurred. Please try again.")
    } finally {
      setLoading(false)
    }
  }

  return (
    <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1, width: "100%" }}>
      <Typography variant="h6" gutterBottom>
        Reset Your Password
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Enter your email address and we'll send you a link to reset your password.
      </Typography>

      {success ? (
        <Alert severity="success" sx={{ mb: 3 }}>
          Password reset email sent. Please check your inbox.
        </Alert>
      ) : (
        <>
          {error && (
            <Alert severity="error" sx={{ mb: 3 }}>
              {error}
            </Alert>
          )}

          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={handleChange}
            error={!!error}
          />

          <LoadingButton type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }} loading={loading}>
            Send Reset Link
          </LoadingButton>
        </>
      )}

      <Box sx={{ textAlign: "center" }}>
        <Link component={RouterLink} to="/login" variant="body2">
          Back to login
        </Link>
      </Box>
    </Box>
  )
}

export default ForgotPassword

